import React from 'react'
import styled from 'styled-components'

const ICSALogoSVG = props => (
  <StyledICSALogoSVG
    x="0px"
    y="0px"
    viewBox="0 0 209 12"
    height={props.height}
    color={props.color}
    aboveHeight={props.aboveHeight}
  >
    <path
      d="M33.4001 3.5H31.1001V2.8H36.5001V3.5H34.2001V10.7H33.4001V3.5Z"
      fill="#1D0E46"
    />
    <path
      d="M37.5 2.2H38.2V5.9C38.5 5.3 39.2 4.8 40 4.8C41.5 4.8 42 5.8 42 7.3V10.7H41.3V7.2C41.3 6.2 41.1 5.3 39.9 5.3C38.6 5.3 38.2 6.5 38.2 7.5V10.6H37.5V2.2V2.2Z"
      fill="#1D0E46"
    />
    <path
      d="M47.6999 10.5C47.1999 10.7 46.5999 10.8 45.9999 10.8C44.0999 10.8 43.3999 9.5 43.3999 7.8C43.3999 6 44.3999 4.8 45.7999 4.8C47.3999 4.8 48.0999 6.1 48.0999 7.7V8H44.1999C44.1999 9.2 44.8999 10.2 46.0999 10.2C46.5999 10.2 47.3999 10 47.6999 9.8V10.5V10.5ZM47.2999 7.4C47.2999 6.4 46.8999 5.4 45.7999 5.4C44.6999 5.4 44.0999 6.5 44.0999 7.4H47.2999Z"
      fill="#1D0E46"
    />
    <path
      d="M58.1 3.7C57.6 3.4 56.9 3.4 56.3 3.4C54.3 3.4 53.1 4.8 53.1 6.8C53.1 8.8 54.2 10.2 56.3 10.2C56.8 10.2 57.6 10.1 58.1 9.9V10.6C57.7 10.9 56.8 10.9 56.3 10.9C53.8 10.9 52.3 9.3 52.3 6.8C52.3 4.4 53.8 2.7 56.3 2.7C56.8 2.7 57.7 2.8 58.1 3V3.7Z"
      fill="#1D0E46"
    />
    <path
      d="M60.1001 2.2H60.8001V5.9C61.1001 5.3 61.8001 4.8 62.6001 4.8C64.1001 4.8 64.6001 5.8 64.6001 7.3V10.7H63.9001V7.2C63.9001 6.2 63.7001 5.3 62.5001 5.3C61.2001 5.3 60.8001 6.5 60.8001 7.5V10.6H60.1001V2.2V2.2Z"
      fill="#1D0E46"
    />
    <path
      d="M69.6999 9.8C69.3999 10.5 68.5999 10.9 67.7999 10.9C66.1999 10.9 65.8999 9.8 65.8999 9.3C65.8999 7.4 67.9999 7.3 69.4999 7.3H69.5999V6.9C69.5999 5.9 69.1999 5.4 68.2999 5.4C67.6999 5.4 67.0999 5.5 66.5999 5.9V5.2C66.9999 5 67.7999 4.8 68.2999 4.8C69.6999 4.8 70.2999 5.4 70.2999 6.9V9.4C70.2999 9.9 70.2999 10.2 70.3999 10.6H69.6999V9.8V9.8ZM69.6999 7.8H69.4999C68.2999 7.8 66.7999 7.9 66.7999 9.2C66.7999 10 67.2999 10.2 67.9999 10.2C69.6999 10.2 69.6999 8.7 69.6999 8.1V7.8Z"
      fill="#1D0E46"
    />
    <path
      d="M72.1001 6.2C72.1001 5.6 72.1001 5.3 72.1001 4.9H72.8001V6C73.1001 5.4 73.5001 4.8 74.3001 4.8C74.5001 4.8 74.7001 4.8 74.8001 4.9V5.6C74.7001 5.6 74.5001 5.5 74.3001 5.5C73.2001 5.5 72.9001 6.8 72.9001 7.8V10.6H72.2001V6.2H72.1001Z"
      fill="#1D0E46"
    />
    <path
      d="M78.3 5.5H77V9.2C77 9.7 77.2 10.2 77.8 10.2C78.1 10.2 78.3 10.1 78.5 10.1V10.7C78.3 10.8 78 10.9 77.6 10.9C76.3 10.9 76.3 10 76.3 9V5.5H75.2V4.9H76.3V3.5L77 3.3V4.9H78.3V5.5Z"
      fill="#1D0E46"
    />
    <path
      d="M83.5 10.5C83 10.7 82.4 10.8 81.8 10.8C79.9 10.8 79.2 9.5 79.2 7.8C79.2 6 80.2 4.8 81.6 4.8C83.2 4.8 83.9 6.1 83.9 7.7V8H80C80 9.2 80.7 10.2 81.9 10.2C82.4 10.2 83.2 10 83.5 9.8V10.5ZM83.1 7.4C83.1 6.4 82.7 5.4 81.6 5.4C80.5 5.4 79.9 6.5 79.9 7.4H83.1Z"
      fill="#1D0E46"
    />
    <path
      d="M85.3 6.2C85.3 5.6 85.3 5.3 85.3 4.9H86V6C86.3 5.4 86.7 4.8 87.5 4.8C87.7 4.8 87.9 4.8 88 4.9V5.6C87.9 5.6 87.7 5.5 87.5 5.5C86.4 5.5 86.1 6.8 86.1 7.8V10.6H85.4V6.2H85.3Z"
      fill="#1D0E46"
    />
    <path
      d="M92.6999 10.5C92.1999 10.7 91.5999 10.8 90.9999 10.8C89.0999 10.8 88.3999 9.5 88.3999 7.8C88.3999 6 89.3999 4.8 90.7999 4.8C92.3999 4.8 93.0999 6.1 93.0999 7.7V8H89.1999C89.1999 9.2 89.8999 10.2 91.0999 10.2C91.5999 10.2 92.3999 10 92.6999 9.8V10.5ZM92.2999 7.4C92.2999 6.4 91.8999 5.4 90.7999 5.4C89.6999 5.4 89.0999 6.5 89.0999 7.4H92.2999Z"
      fill="#1D0E46"
    />
    <path
      d="M99.0001 10.7H98.3001V9.8C97.9001 10.5 97.3001 10.9 96.5001 10.9C94.9001 10.9 94.1001 9.6 94.1001 7.9C94.1001 6.1 94.8001 4.9 96.5001 4.9C97.6001 4.9 98.2001 5.7 98.3001 6V2.2H99.0001V10.7ZM96.6001 10.2C97.9001 10.2 98.3001 8.8 98.3001 7.8C98.3001 6.7 97.9001 5.4 96.6001 5.4C95.2001 5.4 94.9001 6.7 94.9001 7.8C94.9001 8.9 95.3001 10.2 96.6001 10.2Z"
      fill="#1D0E46"
    />
    <path
      d="M110.1 4.3C109.5 4 108.7 3.9 108.1 3.9C106.3 3.9 105.2 5.1 105.2 6.8C105.2 8.4 106.2 9.6 107.9 9.6C108.3 9.6 108.7 9.6 108.9 9.5V7.4H107.2V6.2H110.4V10.5C109.6 10.7 108.7 10.9 107.8 10.9C105.2 10.9 103.5 9.6 103.5 7C103.5 4.3 105.2 2.8 107.8 2.8C108.7 2.8 109.4 2.9 110.1 3.1V4.3Z"
      fill="#1D0E46"
    />
    <path
      d="M114.6 4.7C116.3 4.7 117.7 5.9 117.7 7.8C117.7 9.5 116.6 10.8 114.6 10.8C112.7 10.8 111.6 9.5 111.6 7.8C111.6 5.9 112.9 4.7 114.6 4.7ZM114.6 9.6C115.8 9.6 116.1 8.6 116.1 7.6C116.1 6.7 115.6 5.9 114.6 5.9C113.6 5.9 113.1 6.8 113.1 7.6C113.2 8.6 113.5 9.6 114.6 9.6Z"
      fill="#1D0E46"
    />
    <path
      d="M118.2 4.89999H119.9L121.3 9.09999L122.7 4.89999H124.2L122.1 10.7H120.4L118.2 4.89999Z"
      fill="#1D0E46"
    />
    <path
      d="M129.8 10.4C129.2 10.7 128.6 10.9 127.8 10.9C125.9 10.9 124.8 9.8 124.8 7.9C124.8 6.2 125.7 4.8 127.5 4.8C129.7 4.8 130.3 6.3 130.3 8.3H126.3C126.4 9.2 127 9.8 128 9.8C128.7 9.8 129.4 9.5 129.9 9.2V10.4H129.8ZM128.8 7.2C128.8 6.5 128.4 5.8 127.6 5.8C126.8 5.8 126.3 6.4 126.3 7.2H128.8V7.2Z"
      fill="#1D0E46"
    />
    <path
      d="M131.5 4.9H132.8V6.2C132.9 5.7 133.5 4.7 134.4 4.7C134.5 4.7 134.7 4.7 134.9 4.7V6.2C134.8 6.1 134.5 6.1 134.2 6.1C133 6.1 133 7.6 133 8.5V10.6H131.5V4.9V4.9Z"
      fill="#1D0E46"
    />
    <path
      d="M136.1 4.9H137.5V5.7C138 5 138.6 4.8 139.4 4.8C140.8 4.8 141.4 5.8 141.4 7.1V10.8H139.9V7.6C139.9 6.9 139.9 5.9 138.9 5.9C137.8 5.9 137.6 7.1 137.6 7.8V10.6H136.1V4.9Z"
      fill="#1D0E46"
    />
    <path
      d="M143.2 5.2C143.8 4.9 144.6 4.8 145.2 4.8C147 4.8 147.7 5.5 147.7 7.3V8C147.7 8.6 147.7 9 147.7 9.5C147.7 9.9 147.7 10.3 147.8 10.8H146.5C146.4 10.5 146.4 10.1 146.4 9.9C146 10.5 145.3 10.9 144.6 10.9C143.6 10.9 142.6 10.3 142.6 9.2C142.6 8.3 143 7.8 143.6 7.5C144.2 7.2 144.9 7.2 145.6 7.2H146.4C146.4 6.3 146 5.9 145.1 5.9C144.5 5.9 143.8 6.1 143.3 6.5L143.2 5.2ZM145 9.7C145.5 9.7 145.8 9.5 146.1 9.2C146.3 8.9 146.4 8.5 146.4 8H145.7C145 8 144 8.1 144 9C144 9.5 144.5 9.7 145 9.7Z"
      fill="#1D0E46"
    />
    <path
      d="M149.3 4.9H150.7V5.7C151.2 5 151.8 4.8 152.6 4.8C154 4.8 154.6 5.8 154.6 7.1V10.8H153.1V7.6C153.1 6.9 153.1 5.9 152.1 5.9C151 5.9 150.8 7.1 150.8 7.8V10.6H149.3V4.9Z"
      fill="#1D0E46"
    />
    <path
      d="M159.9 6.1C159.6 6 159.3 5.9 158.9 5.9C158 5.9 157.4 6.6 157.4 7.7C157.4 8.8 157.9 9.6 159 9.6C159.4 9.6 159.9 9.4 160.2 9.3L160.3 10.6C159.9 10.7 159.4 10.8 158.8 10.8C156.9 10.8 155.9 9.5 155.9 7.7C155.9 6 156.9 4.7 158.7 4.7C159.3 4.7 159.8 4.8 160.2 4.9L159.9 6.1Z"
      fill="#1D0E46"
    />
    <path
      d="M165.9 10.4C165.3 10.7 164.7 10.9 163.9 10.9C162 10.9 160.9 9.8 160.9 7.9C160.9 6.2 161.8 4.8 163.6 4.8C165.8 4.8 166.4 6.3 166.4 8.3H162.4C162.5 9.2 163.1 9.8 164.1 9.8C164.8 9.8 165.5 9.5 166 9.2V10.4H165.9ZM164.8 7.2C164.8 6.5 164.4 5.8 163.6 5.8C162.8 5.8 162.3 6.4 162.3 7.2H164.8V7.2Z"
      fill="#1D0E46"
    />
    <path d="M171.5 2.8H170.7V10.7H171.5V2.8Z" fill="#1D0E46" />
    <path
      d="M173.2 6.3C173.2 5.9 173.2 5.4 173.2 4.9H173.9V5.9C174.1 5.4 174.6 4.7 175.8 4.7C177.2 4.7 177.8 5.7 177.8 6.9V10.6H177V7.2C177 6.1 176.6 5.4 175.6 5.4C174.3 5.4 173.9 6.5 173.9 7.5V10.7H173.2V6.3V6.3Z"
      fill="#1D0E46"
    />
    <path
      d="M179.1 9.8C179.5 10 180 10.2 180.6 10.2C181.3 10.2 181.9 9.8 181.9 9.2C181.9 7.8 179.1 8 179.1 6.4C179.1 5.3 180 4.8 181 4.8C181.3 4.8 181.9 4.9 182.4 5.1L182.3 5.7C181.9 5.5 181.4 5.4 181 5.4C180.3 5.4 179.8 5.6 179.8 6.4C179.8 7.5 182.6 7.3 182.6 9.2C182.6 10.4 181.5 10.8 180.6 10.8C180 10.8 179.5 10.7 179 10.5L179.1 9.8Z"
      fill="#1D0E46"
    />
    <path
      d="M186.4 5.5H185.1V9.2C185.1 9.7 185.3 10.2 185.9 10.2C186.2 10.2 186.4 10.1 186.6 10.1V10.7C186.4 10.8 186.1 10.9 185.7 10.9C184.4 10.9 184.4 10 184.4 9V5.5H183.3V4.9H184.4V3.5L185.1 3.3V4.9H186.4V5.5V5.5Z"
      fill="#1D0E46"
    />
    <path
      d="M188.4 3.39999H187.7V2.39999H188.4V3.39999ZM187.7 4.89999H188.4V10.7H187.7V4.89999Z"
      fill="#1D0E46"
    />
    <path
      d="M192.7 5.5H191.4V9.2C191.4 9.7 191.6 10.2 192.2 10.2C192.5 10.2 192.7 10.1 192.9 10.1V10.7C192.7 10.8 192.4 10.9 192 10.9C190.7 10.9 190.7 10 190.7 9V5.5H189.6V4.9H190.7V3.5L191.4 3.3V4.9H192.7V5.5V5.5Z"
      fill="#1D0E46"
    />
    <path
      d="M198.5 9.29999C198.5 9.69999 198.5 10.2 198.5 10.7H197.8V9.69999C197.6 10.2 197.1 10.9 195.9 10.9C194.5 10.9 193.9 9.89999 193.9 8.69999V4.89999H194.6V8.39999C194.6 9.49999 195 10.2 196 10.2C197.3 10.2 197.7 9.09999 197.7 8.09999V4.89999H198.4V9.29999H198.5Z"
      fill="#1D0E46"
    />
    <path
      d="M202.8 5.5H201.5V9.2C201.5 9.7 201.7 10.2 202.3 10.2C202.6 10.2 202.8 10.1 203 10.1V10.7C202.8 10.8 202.5 10.9 202.1 10.9C200.8 10.9 200.8 10 200.8 9V5.5H199.7V4.9H200.8V3.5L201.5 3.3V4.9H202.8V5.5V5.5Z"
      fill="#1D0E46"
    />
    <path
      d="M207.9 10.5C207.4 10.7 206.8 10.8 206.2 10.8C204.3 10.8 203.6 9.5 203.6 7.8C203.6 6 204.6 4.8 206 4.8C207.6 4.8 208.3 6.1 208.3 7.7V8H204.4C204.4 9.2 205.1 10.2 206.3 10.2C206.8 10.2 207.6 10 207.9 9.8V10.5V10.5ZM207.5 7.4C207.5 6.4 207.1 5.4 206 5.4C204.9 5.4 204.3 6.5 204.3 7.4H207.5Z"
      fill="#1D0E46"
    />
    <path
      d="M27.3 1.60001V11.7"
      stroke="#0080C9"
      strokeWidth="0.4522"
      strokeMiterlimit="10"
    />
    <path d="M2.4 3.5H0V10.3H2.4V3.5Z" fill="#1D0E46" />
    <path
      d="M8.8001 5.4C8.3001 5.2 7.9001 5 7.4001 5C6.4001 5 5.6001 5.7 5.6001 6.9C5.6001 8 6.5001 8.7 7.5001 8.7C8.0001 8.7 8.6001 8.6 9.0001 8.4V10.1C8.4001 10.3 7.7001 10.4 7.1001 10.4C4.9001 10.4 3.1001 9.1 3.1001 6.8C3.1001 4.5 4.8001 3.2 7.1001 3.2C7.8001 3.2 8.4001 3.3 9.0001 3.6L8.8001 5.4Z"
      fill="#1D0E46"
    />
    <path
      d="M10 8.39999C10.5 8.59999 11.4 8.89999 12.2 8.89999C12.7 8.89999 13.2 8.79999 13.2 8.39999C13.2 7.19999 9.90005 8.09999 9.90005 5.59999C9.90005 3.99999 11.4 3.39999 12.8 3.39999C13.6 3.39999 14.4 3.49999 15.2 3.79999L15 5.39999C14.5 5.09999 13.8 4.89999 13.2 4.89999C12.6 4.89999 12 4.99999 12 5.29999C12 6.39999 15.5 5.49999 15.5 8.09999C15.5 9.89999 13.9 10.4 12.3 10.4C11.2 10.4 10.5 10.3 9.80005 10.1L10 8.39999Z"
      fill="#1D0E46"
    />
    <path
      d="M21.0001 10.3C21.0001 9.9 20.9001 9.6 20.9001 9.2C20.4001 10.1 19.7001 10.4 18.7001 10.4C17.4001 10.4 16.1001 9.7 16.1001 8.3C16.1001 6.2 18.4001 6 19.6001 6C20.0001 6 20.4001 6 20.7001 6.1C20.7001 5.2 20.0001 4.9 19.1001 4.9C18.3001 4.9 17.6001 5 16.9001 5.4V3.8C17.7001 3.5 18.6001 3.3 19.6001 3.3C21.3001 3.3 22.8001 4 22.8001 6.1V8.6C22.8001 9.1 22.8001 9.7 22.9001 10.2H21.0001V10.3ZM19.4001 8.9C20.3001 8.9 20.9001 8.1 20.9001 7.3C20.6001 7.3 20.3001 7.3 19.9001 7.3C19.1001 7.3 18.5001 7.5 18.5001 8.2C18.4001 8.6 18.8001 8.9 19.4001 8.9Z"
      fill="#1D0E46"
    />
    <path d="M2.4 2.4L1.2 1.2L0 2.4V0H2.4V2.4Z" fill="#0080C9" />
  </StyledICSALogoSVG>
)

const StyledICSALogoSVG = styled.svg`
  fill: ${props => props.color}};
  height: ${props => props.height};
  @media (min-width: 450px) {
    height: ${props => props.aboveHeight};
  }
`

export default ICSALogoSVG
